$(window).on("scroll", function() {
    if($(window).scrollTop() > 80) {
        //add the background property
        $(".dashboard-navbar").addClass("scrolled");
    } else {
        //remove the background property so it comes transparent again (defined in your css)
        $(".dashboard-navbar").removeClass("scrolled");
    }
});
